import axios from 'axios';
import { ApiError } from '../types/apiError';

/**
 * Extracts a user-friendly error message from any error thrown by axios.
 *
 * API error response shape (new):
 * {
 *   "success": false,
 *   "message": "Request failed",        ← generic, avoid showing this
 *   "error": {
 *     "code": "VALIDATION_ERROR",
 *     "message": "Cannot delete ...",   ← specific, show this
 *     "details": "..."
 *   }
 * }
 *
 * Falls back gracefully for non-API / legacy errors.
 */
export const getApiErrorMessage = (
    error: unknown,
    fallback = 'Something went wrong. Please try again.',
): string => {
    if (axios.isAxiosError(error)) {
        const data = error.response?.data as ApiError | undefined;

        // New structure: nested error.message is the specific user-facing message
        if (data?.error?.message) return data.error.message;

        // Legacy flat structure fallback
        if (data?.message && data.message !== 'Request failed') return data.message;

        // Legacy field-level validation errors
        if (data?.fieldErrors) {
            const first = Object.values(data.fieldErrors)[0];
            if (first) return first;
        }
    }
    if (error instanceof Error) return error.message;
    return fallback;
};
